module.exports = __webpack_public_path__ + "img/footer-logo.134c8223.png";